import 'css-chunk:src/app/containers/Home/UserMenu.scss';export default {
  "UserMenu": "_UserMenu_1l557_1",
  "avatar": "_avatar_1l557_10",
  "name": "_name_1l557_13",
  "UserMenuDropdown": "_UserMenuDropdown_1l557_17",
  "header": "_header_1l557_17",
  "SubMenuItem": "_SubMenuItem_1l557_18",
  "icon": "_icon_1l557_21",
  "clientName": "_clientName_1l557_26"
};